export default "__VITE_ASSET__753792a7__"